module.exports = __webpack_public_path__ + "img/the-national-gambling-helpline-greyscale.5db90bfa.svg";